import GeneralRulesForm from './forms/GeneralRulesForm';
import TemporalParametersForm from './forms/TemporalParametersForm';
import RulesExecutionForm from './forms/RulesExecutionForm';
// import DebtUpdateForm from './forms/DebtUpdateForm';
import EPSSelectionForm from './forms/EPSSelectionForm';
import RemunerationForm from './forms/RemunerationForm';
import { openAlert } from 'modules/alertHandler';
import { FORM_MODE } from 'shared/enums';
import { store } from 'store';
import {
  createMailingRuleAction,
  updateMailingRuleAction,
} from 'modules/mailingRule';
import { setSelectedMailingRuleModeAction } from 'modules/mailingRuleModeNavigation';
import {
  IExpandedMailingRule,
  IPossiblyDraftSelectedEPS,
} from 'interfaces/MailingRule';
import { RemunerationTypeFields } from './interfaces';

export const steps = [
  {
    label: 'Regras Gerais',
    Component: GeneralRulesForm,
  },
  {
    label: 'Parâmetros Temporais',
    Component: TemporalParametersForm,
  },
  {
    label: 'Critérios para execução de Réguas',
    Component: RulesExecutionForm,
  },
  // {
  //   label: 'Atualização de Débito',
  //   Component: DebtUpdateForm,
  // },
  {
    label: 'Seleção de EPS',
    Component: EPSSelectionForm,
  },
  // {
  //   label: 'Remuneração',
  //   Component: RemunerationForm,
  // },
];

export const handleSubmit = (
  values: IExpandedMailingRule,
  setSubmitting: (isSubmitting: boolean) => void,
): void => {
  const storeState = store.getState();
  const selectedMailingRuleModeNavigation =
    storeState.selectedMailingRuleModeNavigation.mode;

  const { _id: id } = values;
  const readyToSubmitMailingRule: IExpandedMailingRule = {
    ...values,
    name: values.name.trim(),
    status: 'CREATED',
  };

  const isUpdating = selectedMailingRuleModeNavigation === FORM_MODE.edit;

  if (isUpdating) {
    store.dispatch(
      openAlert({
        title: 'Atenção!',
        content: `Você tem certeza que deseja editar essa régua de mailing?`,
        primaryButtonAction: updateMailingRuleAction({
          id,
          mailingRule: readyToSubmitMailingRule,
          resetFormSubmitting: setSubmitting,
          successAction: setSelectedMailingRuleModeAction(FORM_MODE.list),
        }),
        secondaryButton: 'Cancelar',
      }),
    );
  } else {
    store.dispatch(
      createMailingRuleAction({
        mailingRule: readyToSubmitMailingRule,
        resetFormSubmitting: setSubmitting,
        successAction: setSelectedMailingRuleModeAction(FORM_MODE.list),
      }),
    );
  }
};

export const handleSubmitDraft = (
  values: IExpandedMailingRule,
  setSubmitting: (isSubmitting: boolean) => void,
): void => {
  const { _id: id } = values;

  if (!values.serviceCategory) {
    store.dispatch(
      openAlert({
        title: 'Atenção!',
        content: `O campo Tipo de atuação é obrigatório para salvar rascunho.`,
      }),
    );
    return;
  }

  if (!values.name) {
    store.dispatch(
      openAlert({
        title: 'Atenção!',
        content: `O campo nome é obrigatório para salvar rascunho.`,
      }),
    );
    return;
  }

  const storeState = store.getState();
  const { mode } = storeState.selectedMailingRuleModeNavigation;
  const isUpdating = mode === FORM_MODE.edit;
  const readyToSubmitMailingRule: IExpandedMailingRule = {
    ...values,
    status: 'DRAFT',
  };

  if (isUpdating) {
    store.dispatch(
      updateMailingRuleAction({
        id,
        mailingRule: readyToSubmitMailingRule,
        resetFormSubmitting: setSubmitting,
        successAction: setSelectedMailingRuleModeAction(FORM_MODE.list),
      }),
    );
  } else {
    store.dispatch(
      createMailingRuleAction({
        mailingRule: readyToSubmitMailingRule,
        resetFormSubmitting: setSubmitting,
        successAction: setSelectedMailingRuleModeAction(FORM_MODE.list),
      }),
    );
  }
};

export const remunerationRules: {
  [key: string]: RemunerationTypeFields[];
} = {
  COMMISSION: [
    'remunerationCommissionId',
    'remunerationBonusId',
    'remunerationGoalIds',
  ],
  VALUE_FIXED: [
    'remunerationFixedIds',
    'remunerationBonusId',
    'remunerationGoalIds',
  ],
  EXEMPTED: [],
};

export const getParsedRemunerationEps = (
  remunerationEps: IPossiblyDraftSelectedEPS,
): {
  [key in RemunerationTypeFields]: boolean;
} => ({
  remunerationCommissionId:
    remunerationEps.remunerationCommissionId &&
    remunerationEps.remunerationCommissionId?.length > 0
      ? true
      : false,
  remunerationFixedIds:
    remunerationEps.remunerationFixedIds &&
    remunerationEps.remunerationFixedIds?.length > 0
      ? true
      : false,
  remunerationBonusId:
    remunerationEps.remunerationBonusId &&
    remunerationEps.remunerationBonusId?.length > 0
      ? true
      : false,
  remunerationGoalIds:
    remunerationEps.remunerationGoalIds &&
    remunerationEps.remunerationGoalIds?.length > 0
      ? true
      : false,
});
